import { render, staticRenderFns } from "./FooterComponentNcph.vue?vue&type=template&id=0e9bb4d2&scoped=true"
import script from "./FooterComponentNcph.vue?vue&type=script&lang=ts"
export * from "./FooterComponentNcph.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentNcph.vue?vue&type=style&index=0&id=0e9bb4d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9bb4d2",
  null
  
)

export default component.exports